import React from 'react';

interface FilterToggleProps {
  id: string;
  labelText: string | React.ReactNode;
  onChange: (id: string, checked: boolean) => void;
  checked?: boolean | string;
}

const FilterToggle = ({
  checked = false,
  id,
  labelText,
  onChange,
}: FilterToggleProps) => {
  const isChecked =
    typeof checked !== 'boolean' && checked.length > 0
      ? JSON.parse(checked)
      : checked;

  return (
    <>
      <label
        className={`filter-toggle ${isChecked ? 'filter-toggle--checked' : ''}`}
      >
        <input
          checked={isChecked}
          className="ch-reader"
          onChange={() => onChange(id, !isChecked)}
          type="checkbox"
        />
        {labelText}
        <span className="filter-toggle__indicator">
          <span className="filter-toggle__indicator-inner" />
        </span>
      </label>
    </>
  );
};

export default FilterToggle;
